import {AlertIcon, FoldIcon} from '@primer/octicons-react'
import type {TimelineMarker} from './AhpTimelineView'
import {describeCompactionSavings, type CompactionMarker} from './compaction-marker'
import styles from './CompactionStatusEntry.module.css'

/**
 * System row reporting a `/compact` result, which otherwise shows as dead air.
 * Not a live region: it mounts for past compactions too, so
 * `useCompactionAnnouncements` handles announcing.
 */
export function CompactionStatusEntry({marker}: {marker: CompactionMarker}) {
  const savings = describeCompactionSavings(marker)

  if (!marker.success) {
    return (
      <div className={styles.row} data-testid="ahp-compaction-status">
        <span className={styles.errorIcon}>
          <AlertIcon size={16} aria-hidden="true" />
        </span>
        <span className={styles.text}>
          <span className={styles.emphasis}>Couldn&apos;t compact the conversation</span>
          {marker.error ? <span className={styles.detail}>{marker.error}</span> : null}
        </span>
      </div>
    )
  }

  return (
    <div className={styles.row} data-testid="ahp-compaction-status">
      <span className={styles.icon}>
        <FoldIcon size={16} aria-hidden="true" />
      </span>
      <span className={styles.text}>
        <span className={styles.emphasis}>Conversation compacted</span>
        {savings ? <span className={styles.detail}>Removed {savings}</span> : null}
        {marker.title ? <span className={styles.detail}>{marker.title}</span> : null}
      </span>
    </div>
  )
}

/** Wraps each compaction marker as a timeline marker row for `timelineMarkers`. */
export function toCompactionTimelineMarkers(markers: readonly CompactionMarker[]): TimelineMarker[] {
  return markers.map(marker => ({
    id: marker.id,
    afterTurnId: marker.afterTurnId,
    node: <CompactionStatusEntry marker={marker} />,
  }))
}
